/* unplugin-vue-components disabled */import { render } from "./TotalSummariesItem.vue?vue&type=template&id=ffd2ba90&scoped=true&ts=true"
import script from "./TotalSummariesItem.vue?vue&type=script&lang=ts"
export * from "./TotalSummariesItem.vue?vue&type=script&lang=ts"

import "./TotalSummariesItem.vue?vue&type=style&index=0&id=ffd2ba90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd2ba90"]])

export default __exports__